import { defineComponent as _defineComponent } from 'vue'

import MenuIcon from '@/components/Icons'
import { AttensiCard } from '@attensi/materia'

export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingComponent',
  props: {
    message: { type: String, required: true },
    heading: { type: String, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props

const __returned__ = { props, get MenuIcon() { return MenuIcon }, get AttensiCard() { return AttensiCard } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})